import FormGroup from './FormGroup'
import Input from './Input'
import Checkbox from './Checkbox'
import Select from './Select'
import Radio from './Radio'
import InputHint from './InputHint'

export default { Group: FormGroup, Input, Checkbox, Select, Radio, InputHint }